import createPaginationItems from '@arpav/components/ArpavTheme/Pagination/createPaginationItems/createPaginationItems';

export default createPaginationItems;
